export default __webpack_public_path__ + "static/media/Uploaded File.911bffc9.svg";